/**
 * Of de werkruimte de sessie uit de URL moet ophalen. De URL is leidend en de
 * store volgt, behalve als de store al op die sessie staat.
 *
 * Tijdens het streamen is de store eigenaar van de berichten. Bij een nieuwe
 * chat maakt de server de sessie midden in de stream aan, en loopt de URL even
 * achter; opnieuw ophalen zou dan het half opgeslagen antwoord terugzetten,
 * dat op de server nog `finished=False` heeft.
 */
export const shouldLoadSession = ({
  urlSessionId,
  activeSessionId,
  researchId,
  isStreaming,
}: {
  urlSessionId?: number;
  activeSessionId?: number;
  researchId?: number;
  isStreaming: boolean;
}): boolean => !researchId && !isStreaming && urlSessionId !== activeSessionId;
